import React from 'react';
import {GoogleReCaptchaProvider} from 'react-google-recaptcha-v3';
import {RECAPTCHA_SITE_KEY} from '../configs/authPublicConfig';

const RecaptchaProvider = ({children}) => {
    return (
        <GoogleReCaptchaProvider
            reCaptchaKey={RECAPTCHA_SITE_KEY}
            useRecaptchaNet
            scriptProps={{
                async: false,
                defer: false,
                appendTo: "head",
                nonce: undefined,
            }}
        >
            {children}
        </GoogleReCaptchaProvider>
    );
};

export default RecaptchaProvider;
